export const ORDER_GET = "store/order/ORDER_GET";
export const ORDER_GET_COMPLETED = "store/order/ORDER_GET_COMPLETED";
export const ORDER_GET_FAILED = "store/order/ORDER_GET_FAILED";
